import React, { useRef, useState } from 'react';
import { __ } from '@wordpress/i18n';

//components
import FileuploadIcon from '../../icons/FileuploadIcon';
import ButtonLabeled from '../ButtonWrapper/components/ButtonLabeled';

const filterFilesByAccept = (files, accept) => {
    if (!accept) return Array.from(files);
    const acceptList = accept.split(',').map(s => s.trim().toLowerCase());
    return Array.from(files).filter(file => {
        return acceptList.some(accepted => {
            if (accepted.startsWith('.')) {
                return file.name.toLowerCase().endsWith(accepted);
            }
            if (accepted.endsWith('/*')) {
                return file.type.startsWith(accepted.slice(0, -1));
            }
            return file.type === accepted;
        });
    });
};

const FileuploadDropZone = ({
    title = __('Carica immagine di copertina', 'soundbetween'),
    description,
    accept,
    multiple = false,
    onFileSelect,
}) => {
    const [isDragging, setIsDragging] = useState(false);
    const inputRef = useRef(null);

    const handleDragOver = (e) => {
        e.preventDefault();
        setIsDragging(true);
    };

    const handleDragLeave = () => {
        setIsDragging(false);
    };

    const handleDrop = (e) => {
        e.preventDefault();
        setIsDragging(false);
        if (!onFileSelect) return;
        const files = filterFilesByAccept(e.dataTransfer.files, accept);
        if (files.length > 0) {
            onFileSelect(multiple ? files : [files[0]]);
        }
    };

    const handleInputChange = (e) => {
        if (!onFileSelect) return;
        const files = Array.from(e.target.files);
        if (files.length > 0) {
            onFileSelect(files);
        }
        // Reset input so the same file can be re-selected
        e.target.value = '';
    };

    const handleButtonClick = () => {
        inputRef.current?.click();
    };

    const rootClass = [
        'fieldFileuploadDropzone',
        isDragging ? 'fieldFileuploadDropzone--dragging' : '',
    ].filter(Boolean).join(' ');

    return (
        <div
            className={rootClass}
            onDragOver={handleDragOver}
            onDragLeave={handleDragLeave}
            onDrop={handleDrop}
        >
            <div className="fieldFileuploadDropzone__inner">
                <FileuploadIcon/>
                <span className="title">{title}</span>
                <span className="description">
                    {description || __('Trascina qui il tuo contenuto', 'soundbetween')}
                </span>

                <span className="description orText">{__('oppure', 'soundbetween')}</span>
                <ButtonLabeled onClick={handleButtonClick}>
                    {__('Carica dal computer', 'soundbetween')}
                </ButtonLabeled>

                {onFileSelect && (
                    <input
                        ref={inputRef}
                        type="file"
                        accept={accept}
                        multiple={multiple}
                        style={{ display: 'none' }}
                        onChange={handleInputChange}
                        aria-hidden="true"
                        tabIndex={-1}
                    />
                )}
            </div>
        </div>
    );
};

export default FileuploadDropZone;
